@for (d of stack(); track d.id; let i = $index) {
  <div
    class="scrim on"
    [class.scrim--stacked]="i > 0"
    [style.z-index]="scrimZ(i)"
    [style.align-items]="align(d)"
    [style.justify-content]="justify(d)"
    [attr.data-dialog-id]="d.id"
    (click)="onBackdrop($event, d)"
  >
    <app-dialog-frame
      appTabTrap
      [isTop]="i === topIndex()"
      [instance]="d"
      [zIndex]="panelZ(i)"
    />
  </div>
}
